import { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "@/app/hooks";
import { clearSelectedAddress, setSelectedAddress } from "@/shared/store/address.slice";
import { isValidUUID } from "@/features/properties/model/guestSession";

const ADDRESS_STORAGE_KEY = "selectedAddress";

export const useAddress = () => {
  const dispatch = useAppDispatch();
  const selectedAddress = useAppSelector((s) => s.address.selectedAddress);

  const [isAddressHydrated, setIsAddressHydrated] = useState(false);

  useEffect(() => {
    const persistedAddress = window.localStorage.getItem(ADDRESS_STORAGE_KEY);

    if (!selectedAddress && persistedAddress) {
      if (!isValidUUID(persistedAddress) && persistedAddress !== "__add__") {
        window.localStorage.removeItem(ADDRESS_STORAGE_KEY);
      } else {
        dispatch(setSelectedAddress(persistedAddress));
      }
    }

    setIsAddressHydrated(true);
  }, [dispatch, selectedAddress]);

  const setAddress = useCallback(
    (address: string) => {
      window.localStorage.setItem(ADDRESS_STORAGE_KEY, address);
      dispatch(setSelectedAddress(address));
    },
    [dispatch]
  );

  const clearAddress = useCallback(() => {
    window.localStorage.removeItem(ADDRESS_STORAGE_KEY);
    dispatch(clearSelectedAddress());
  }, [dispatch]);

  return {
    selectedAddress,
    setSelectedAddress: setAddress,
    clearSelectedAddress: clearAddress,
    isAddressHydrated,
  };
};
